import { API_DOCS_COPY, API_DOCS_UPLOAD } from 'config'

import Api from './api'

export * from './api'
export * from './apis'

export const uploadFiles = (data: any, files: Array<File>) => {
  return Api.uploadFiles(API_DOCS_UPLOAD, data, {}, files)
}

/**
 * Duplicate files the current loan already holds into another of its folders (e.g. an exception
 * attachment into `loan/<n>/document`). Resolves to the new keys, in the order given.
 */
export const copyS3Files = (keys: string[], path: string): Promise<string[]> => {
  return Api.post(API_DOCS_COPY, { keys, path })
}
